<template>
    <section class="data-page">
        <div class="row  justify-content-center mt-5 mt-5" >
          <div class="col-sm-12">
            <div   class="form-content p-5">
                <h6 class="text-center mb-2">Convert  Airtime at <b>{{100-message.discount}}% </b> Cashback</h6>


              <div class="row justify-content-center">
                <div class="col-sm-12">
              <div class="form-group mb-3">
                <p class="text-center">*The phone number entered will be credited*</p>
                <!-- <label>Enter  phone number.</label>
               <input type="text" class="form-text"  v-model="message.phone"   required> -->
              </div>

              <div class="form-group mb-2">
                <label>Enter Airtime amount to convert.<span class="text-danger">*</span></label>
                <input type="text" class="form-input" v-on:keyup="calculatePrice()" v-model="message.value"  required>
              </div>
              <p class=" text-center mb-2 mt-2">Amount you will receive in Mpesa.<b>Ksh.{{formatPrice(message.amount)}}</b></p>

                                  <div class="text-success" v-if="role==='true'">
                                    <p class="text-center text-success">Click button below to convert airtime to cash instantly.In case of a delay Please Call/SMS/Watsap us at <b>0796730634</b></p>
                                    <!-- <p class="text-center"><b>Please contact us in case of deplay to receive your conversion.</b>  </p> -->
                                </div>
              <div class="text-center"><button v-on:click="submit()" type="submit" class="btn btn-success btn-block" v-if="role==='false'">Continue <i class=" 	fa fa-arrow-right"></i></button></div>
            <div class="text-center"><a  v-bind:href="'tel:'+phone+''"  class="btn btn-success btn-block" v-if="role==='true'">Convert Now!</a></div>
              </div>
              </div>
<div class="container text-center mt-5">
    <a href="https://play.google.com/store/apps/details?id=io.ionic.airtimetocash" target="_blank">
        <img
            src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
            alt="Get it on Google Play"
            style="width:100px;height:auto;opacity: 0.7;">
    </a>
</div>
              </div>

          </div>
        </div>
</section>
</template>
<script>
    // import moment from 'moment'
    export default {
        name: 'Index',
        components: {

        },
        data(){
            return {
               message:{discount:'0',credit:'0',amount:'0',type:'airtime',receiving_no:'',source:'web-portal'},
                role:'false',
                phone:'',

            }
        },
        created(){
              this.getDiscount();
        },
        methods: {

            getDiscount(){
                let uri =`/api/auth/discount`;
                this.$axios.get(uri, { headers: { Authorization: 'Bearer '+localStorage.getItem('token')}}).then((response) => {
                   this.message.discount=response.data.mpesa.rate;
                   this.message.receiving_no=response.data.receiving_no.number;
                }).catch(warning => {

                });
            },
            submit(){
              if(this.message.value<10 || this.message.value>10000){
                return false;
              }
                     this.phone=encodeURIComponent('*140*'+this.message.value+'*'+this.message.receiving_no+'#');
                   this.role='true';
              },
              calculatePrice(){
                 this.role='false';
           this.message.amount=+this.message.value-((+this.message.discount * +this.message.value)/100);
          },
            formatPrice(value) {
                let val = (value/1).toFixed(2).replace('.', '.');
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }
        },
    }

</script>



// WEBPACK FOOTER //
// src/components/Index.vue